










import { defineComponent, onMounted } from '@nuxtjs/composition-api';
import { useRecentlyViewedProducts } from '~/features/product';

export default defineComponent({
  name: 'ProductPageRelatedProducts',
  setup() {
    const { fetchProducts, items, isFetching } = useRecentlyViewedProducts();

    onMounted(async () => {
      await fetchProducts();
    });

    return {
      items,
      isFetching,
    };
  },
});
